export default {
  CLEAR_DATA: Symbol('CLEAR_DATA'),
  SAVE_DATA: Symbol('SAVE_DATA'),
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  SET_PAGINATION: Symbol('SET_PAGINATION'),
  RESET_PAGINATION: Symbol('RESET_PAGINATION'),
  SET_TIME: Symbol('SET_TIME'),
  RESET: Symbol('RESET'),
  REFUND_PAGE: Symbol('REFUND_PAGE'),
};
